import React, { useEffect, useState } from 'react';
import { AnimatePresence, motion } from 'framer-motion';
import { XIcon } from 'lucide-react';
const notices = [{
  name: 'Camila R.',
  city: 'Guadalajara, México',
  product: 'Atlas Kinesio-Visual + 6 bonos'
}, {
  name: 'Nicolás B.',
  city: 'Medellín, Colombia',
  product: 'Atlas Kinesio-Visual + 6 bonos'
}, {
  name: 'Sofía D.',
  city: 'Lima, Perú',
  product: 'Atlas Kinesio-Visual + 6 bonos'
}, {
  name: 'Andrés V.',
  city: 'Santiago, Chile',
  product: 'Atlas Kinesio-Visual + 6 bonos'
}, {
  name: 'Valeria P.',
  city: 'Quito, Ecuador',
  product: 'Atlas Kinesio-Visual + 6 bonos'
}, {
  name: 'Mateo G.',
  city: 'Córdoba, Argentina',
  product: 'Atlas Kinesio-Visual + 6 bonos'
}];
export function PurchaseToast() {
  const [index, setIndex] = useState(0);
  const [visible, setVisible] = useState(false);
  const [dismissed, setDismissed] = useState(false);
  useEffect(() => {
    if (dismissed) return;
    const show = window.setTimeout(() => setVisible(true), 6000);
    return () => window.clearTimeout(show);
  }, [dismissed]);
  useEffect(() => {
    if (!visible || dismissed) return;
    const hide = window.setTimeout(() => setVisible(false), 7000);
    const next = window.setTimeout(() => {
      setIndex(current => (current + 1) % notices.length);
      setVisible(true);
    }, 22000);
    return () => {
      window.clearTimeout(hide);
      window.clearTimeout(next);
    };
  }, [visible, index, dismissed]);
  const notice = notices[index];
  return <div className="pointer-events-none fixed bottom-4 left-4 z-40 max-w-[calc(100vw-2rem)]" data-id="element-212" data-mp="1fhbt9ci0dtyc">
      <AnimatePresence data-id="element-213" data-mp="1kgocln9o8iw6">
        {visible && !dismissed && <motion.aside initial={{
        opacity: 0,
        y: 12,
        scale: 0.98
      }} animate={{
        opacity: 1,
        y: 0,
        scale: 1
      }} exit={{
        opacity: 0,
        y: 12,
        scale: 0.98
      }} transition={{
        duration: 0.24,
        ease: [0.23, 1, 0.32, 1]
      }} aria-live="polite" className="pointer-events-auto flex w-[19rem] items-start gap-3 rounded-2xl bg-white p-4 shadow-lift ring-1 ring-blue-100" data-id="element-214" data-mp="1kfdbjv7m1p8r">
            <div className="min-w-0 flex-1" data-id="element-215" data-mp="1v36f3hmy4yp1">
              <p className="inline-flex items-center gap-2 text-xs font-extrabold uppercase tracking-[0.14em] text-mint-600" data-id="element-216" data-mp="1v253nc20qa6s">
                <span className="h-2 w-2 rounded-full bg-mint-500" aria-hidden="true" data-id="element-217" data-mp="28wfj12s4ks06" />
                Compra verificada
              </p>
              <p className="mt-2 text-sm font-bold text-ink" data-id="element-218" data-mp="1h2nakkhowarm">
                {notice.name} de {notice.city}
              </p>
              <p className="truncate text-sm text-blue-900/70" data-id="element-219" data-mp="1c5dmp99y875w">
                Compró <span className="font-semibold text-blue-700" data-id="element-220" data-mp="1q4d2drfhhbpx">{notice.product}</span>
              </p>
              <p className="mt-1 text-xs text-blue-900/45" data-id="element-221" data-mp="1l48rcgxch973">hace 2 minutos</p>
            </div>
            <button type="button" onClick={() => setDismissed(true)} aria-label="Cerrar aviso" className="rounded-md p-1 text-blue-900/40 transition-colors duration-150 ease-calm hover:bg-blue-50 hover:text-blue-700 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-blue-300" data-id="element-222" data-mp="31ih3dhkho04h">
              <XIcon className="h-4 w-4" aria-hidden="true" data-id="element-223" data-mp="390f1kpx7zose" />
            </button>
          </motion.aside>}
      </AnimatePresence>
    </div>;
}